<template>
  <Modal
    centered
    @close="$emit('onModalClose')"
  >
    <template slot="body">
      <BaseTextH1 class="text-center py-3">
        {{ $t('signup-to-validate-your-picks') }}
      </BaseTextH1>
      <Register />
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Molecules/Modal'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import Register from '@/pages/Auth/Routes/Register/Register'

export default {
  name: 'RegistrationModal',
  components: {
    BaseTextH1,
    Register,
    Modal,
  },
}
</script>

<style scoped>

</style>
